import React from 'react';
import styled from 'styled-components';

import { layout } from 'src/components/base';

// Prerequisites before replacing this with @prisjakt/ui/checkbox:
// 1. Change selected color on @prisjakt/ui/card from yellow to blue
// 2. Remove inner margin from @prisjakt/ui/checkbox
// 3. Maybe allow @prisjakt/ui/checkbox to be controlled (i.e. remove requirement of onChange)
import CheckIcon from 'mdi-react/CheckIcon';

type Props = {
  className?: string;
  selected: boolean;
};

const SIZE = 18;

export const CompareCheckbox = (props: Props) => {
  return (
    <CheckboxWrapper className={props.className}>
      <SelectedCheckbox $selected={props.selected}>
        {props.selected && <CheckIcon size={14} />}
      </SelectedCheckbox>
    </CheckboxWrapper>
  );
};

const CheckboxWrapper = styled.div`
  position: absolute;
  top: calc(${layout.measurements.spacing100} - 4px);
  left: calc(${layout.measurements.spacing100} - 4px);
  z-index: 2;
  padding: ${layout.measurements.spacing025};
  background: rgba(255, 255, 255, 0.72);
  border-radius: 4px;
`;

type SelectedCheckboxProps = {
  $selected: boolean;
};

export const SelectedCheckbox = styled.div<SelectedCheckboxProps>`
  width: ${SIZE}px;
  height: ${SIZE}px;
  background: ${p => (p.$selected ? p.theme.colors.yellove500 : 'transparent')};
  box-shadow: ${p =>
    p.$selected ? 'none' : `inset 0 0 0 1px ${p.theme.lines.quaternary}`};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${p => p.theme.colors.base0};
`;
